export const ethereumData = {
    'Ethereum address': '0x397B48513a942d5303F3bE0fc6c63d86BAFA9c9D',
};

export const bankingData = {
    'SWIFT/BIC': 'TRWIBEB1XXX',
    'IBAN': 'BE53 9670 3205 7553',
    'Account Holder': 'Sihtasutus Felfele',
    'Bank Address': `TransferWise Europe SA
Square de Meeûs 38 bte 40
Brussels 1000
Belgium`,
};
